
const COIN_EMOJIS = ['💰', '🪙', '💎', '✨', '⭐', '🌟']

let _stylesInjected = false

export const ensureRewardStyles = () => {
  if (_stylesInjected || typeof document === 'undefined') return
  _stylesInjected = true
  const style = document.createElement('style')
  style.dataset.catRunningRewardFx = 'true'
  style.textContent = `
  @keyframes crCfFlash { 0%{opacity:0} 18%{opacity:1} 100%{opacity:0} }
  .cr-cf-coin { position:absolute; pointer-events:none; z-index:60;
    transform:translate(-50%,-50%) scale(1); will-change:transform,opacity; user-select:none; }
  .cr-cf-coin-drop { position:absolute; top:-40px; pointer-events:none; z-index:59;
    will-change:transform,opacity; user-select:none; }
  .cr-cf-flash { position:absolute; inset:0; pointer-events:none; z-index:58;
    animation:crCfFlash .6s ease-out forwards; }
  @keyframes crCfTotalPop { 0%{transform:scale(1)} 40%{transform:scale(1.35)} 100%{transform:scale(1)} }
  .cr-cf-total-pop { animation: crCfTotalPop .55s cubic-bezier(.34,1.56,.64,1); transform-origin:center; }
  `
  document.head.appendChild(style)
}

export const rewardTier = (total) => {
  const t = Math.max(0, total | 0)
  if (t >= 40) return 3
  if (t >= 20) return 2
  if (t >= 9) return 1
  return 0
}

export const burstCoins = (container, count) => {
  if (!container || count <= 0) return
  ensureRewardStyles()
  const w = container.clientWidth || 400
  const h = container.clientHeight || 700
  const cx = w / 2
  const cy = h / 2
  for (let i = 0; i < count; i++) {
    const el = document.createElement('div')
    el.className = 'cr-cf-coin'
    el.textContent = COIN_EMOJIS[Math.floor(Math.random() * COIN_EMOJIS.length)]
    el.style.left = cx + 'px'
    el.style.top = cy + 'px'
    el.style.fontSize = 22 + Math.random() * 22 + 'px'
    el.style.transform = 'translate(-50%,-50%) scale(1)'
    el.style.opacity = '1'
    container.appendChild(el)
    const angle = Math.random() * Math.PI * 2
    const radius = 120 + Math.random() * 260
    const dx = Math.cos(angle) * radius
    const dy = Math.sin(angle) * radius * 0.75 + 60
    const rot = (Math.random() * 720 - 360) | 0
    const sc = 0.8 + Math.random() * 0.6
    void el.offsetHeight
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.transition =
          'transform 1.1s cubic-bezier(.22,.9,.38,1), opacity .9s ease-out'
        el.style.transform = `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) rotate(${rot}deg) scale(${sc})`
        el.style.opacity = '0'
      })
    })
    setTimeout(() => el.remove(), 1400)
  }
}

const dropOneCoin = (container) => {
  const el = document.createElement('div')
  el.className = 'cr-cf-coin-drop'
  el.textContent = Math.random() < 0.5 ? '💰' : '🪙'
  el.style.fontSize = 18 + Math.random() * 14 + 'px'
  el.style.left = 4 + Math.random() * 90 + '%'
  el.style.opacity = '1'
  container.appendChild(el)
  const dropDist = (container.clientHeight || window.innerHeight || 800) + 80
  const fallMs = 1100 + Math.random() * 500
  requestAnimationFrame(() => {
    el.style.transition = `transform ${fallMs}ms linear, opacity ${fallMs}ms ease-in`
    el.style.transform = `translateY(${dropDist}px) rotate(${((Math.random() * 720 - 360) | 0)}deg)`
    el.style.opacity = '0.2'
  })
  setTimeout(() => el.remove(), fallMs + 200)
}

export const rainCoins = (container, count, duration) => {
  if (!container) return
  const total = Math.max(0, count | 0)
  if (total <= 0) return
  ensureRewardStyles()
  const dur = duration || 800
  const n = Math.min(120, total)
  const interval = dur / n
  const timers = []
  for (let i = 0; i < n; i++) {
    timers.push(setTimeout(() => dropOneCoin(container), i * interval))
  }
  return () => timers.forEach((t) => clearTimeout(t))
}

export const flashScreen = (container, color) => {
  if (!container) return
  ensureRewardStyles()
  const fl = document.createElement('div')
  fl.className = 'cr-cf-flash'
  fl.style.background = color || 'rgba(255,215,0,0.45)'
  container.appendChild(fl)
  setTimeout(() => fl.remove(), 650)
}

export const playRewardBurst = (container, total) => {
  const tier = rewardTier(total)
  if (tier <= 0) return 0
  const counts = [0, 10, 22, 48]
  burstCoins(container, counts[tier])
  if (tier >= 2) {
    const flashColor = tier >= 3 ? 'rgba(255,200,40,0.55)' : 'rgba(255,215,0,0.35)'
    flashScreen(container, flashColor)
  }
  return tier
}

export const getRouletteDuration = (target) =>
  1.8 * Math.min(1000, Math.max(600, 400 + Math.sqrt(Math.max(0, target)) * 18))

export const animateCount = (target, duration, onUpdate, onComplete) => {
  const to = Math.max(0, target | 0)
  if (to <= 0 || duration <= 0) {
    onUpdate(to, 1)
    onComplete && onComplete()
    return () => {}
  }
  const start = performance.now()
  let rafId = 0
  let cancelled = false
  const tick = (now) => {
    if (cancelled) return
    const p = Math.min(1, (now - start) / duration)
    const eased = 1 - Math.pow(1 - p, 3)
    onUpdate(Math.floor(to * eased), p)
    if (p < 1) {
      rafId = requestAnimationFrame(tick)
    } else {
      onUpdate(to, 1)
      onComplete && onComplete()
    }
  }
  rafId = requestAnimationFrame(tick)
  return () => {
    cancelled = true
    cancelAnimationFrame(rafId)
  }
}
